import { FC, ReactNode } from "react";
import { Flex, Heading } from "@chakra-ui/react";
import { ReferAFriendAlert } from "~/features/Referral/ReferAFriendAlert";
import { useShowReferAFriend } from "~/features/Referral/useShowReferAFriend";

interface Props {
  heading: ReactNode;
  subtitle?: ReactNode;
}

export const Headings: FC<Props> = ({ heading, subtitle }) => {
  const showRAF = useShowReferAFriend();

  return (
    <Flex direction="column" gap={{ base: 2, md: 4 }}>
      <Flex direction="column" gap={2}>
        <Heading as="h1" textAlign="center" variant="th-h2">
          {heading}
        </Heading>
      </Flex>
      {subtitle && (
        <Heading as="h2" textAlign="center" variant="th-h5">
          {subtitle}
        </Heading>
      )}
      {showRAF && (
        <Flex justify="center" mt={2} w="full">
          <ReferAFriendAlert
            bgColor="th.yellow1"
            maxW="1050px"
            page="planSelect"
          />
        </Flex>
      )}
    </Flex>
  );
};
